import React from 'react';
import PressureHolderQuantity from 'shared/components/carriers/PressureHolderQuantity';
import PressureHolderType from 'shared/components/carriers/PressureHolderType';

const PressureHolder = (props) => (
  <div className="hardware-section mb-3">
    <h5 className="hardware-title mb-2">Hardware</h5>
    <YesPressureHolder {...props} />
  </div>
);

const YesPressureHolder = (props) => {
  const { validator, parameters, pressureHolderTypeTooltip } = props;

  return (
    <>
      <PressureHolderType {...props} tooltip={pressureHolderTypeTooltip}>
        {validator.message(`Pressure Holder Type`, parameters.pressure_holder_type, 'required')}
      </PressureHolderType>
      <div className="row">
        <div className="col-lg-6">
          <PressureHolderQuantity {...props} >
            {parameters.pressure_holder_type
              && parameters.pressure_holder_type !== 'none'
              && validator.message(`Pressure Holder Quantity`, parameters.pressure_holder_quantity, 'required|integer|min:1,num')}
          </PressureHolderQuantity>
        </div>
      </div>
    </>
  );
};

export default PressureHolder;
